module.exports = __webpack_public_path__ + "static/media/person.eed5ce8b.svg";